import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, reactive } from "vue";
import { SalePhase } from "@manifoldxyz/collectible-sdk";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";
import ButtonComponent from "./ButtonComponent.vue";
import ClaimDialog from "./ClaimDialog.vue";

interface ClaimProps {
  asCarousel?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Claim',
  props: {
    asCarousel: { type: Boolean }
  },
  emits: ["connect"],
  setup(__props: any, { emit }) {

const props = __props;

const componentState = reactive<{ isCollectibleOpen: boolean }>({ isCollectibleOpen: false });

const store = useStore();

const isButtonDisabled = computed(() => {
  return Boolean(
    !store.walletAddress ||
      store.salePhase !== SalePhase.CLAIM ||
      store.claimEligibility?.amount === 0 ||
      store.claimEligibility?.remainingAmount === 0
  );
});
const messaging = useMessaging();
const buttonText = computed(() => {
  if (store.salePhase === SalePhase.CLAIM) {
    if (!store.walletAddress) {
      return messaging.CLAIM_BUTTON_CONNECT_WALLET;
    }

    if (store.claimEligibility?.amount === 0) {
      return messaging.CLAIM_BUTTON_INELIGIBILITY;
    }

    if (store.claimEligibility?.remainingAmount === 0) {
      return messaging.CLAIM_BUTTON_ALREADY_MINTED;
    }

    return messaging.CLAIM_BUTTON_CTA;
  } else if (store.salePhase === SalePhase.TO_CLAIM || store.salePhase === SalePhase.LOADING) {
    return messaging.CLAIM_BUTTON_CLAIM_NOT_STARTED;
  }

  throw new Error(
    "Programmer error: `claim` button should not be rendered if `mintCountdownType` is not `CLAIM` or `TO_CLAIM`"
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(store).walletAddress)
      ? (_openBlock(), _createBlock(ButtonComponent, {
          key: 0,
          "is-loading": _unref(store).isFetchingClaimEligibility,
          disabled: isButtonDisabled.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (componentState.isCollectibleOpen = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(buttonText.value), 1)
          ]),
          _: 1
        }, 8, ["is-loading", "disabled"]))
      : (_openBlock(), _createBlock(ButtonComponent, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('connect')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(buttonText.value), 1)
          ]),
          _: 1
        })),
    (componentState.isCollectibleOpen)
      ? (_openBlock(), _createBlock(ClaimDialog, {
          key: 2,
          "as-carousel": props.asCarousel,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (componentState.isCollectibleOpen = false))
        }, null, 8, ["as-carousel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})